/**
 * Export types shared between frontend and backend
 */

export enum InvalidEmailHandling {
  SKIP = 'SKIP',           // Don't export contacts with invalid emails
  INCLUDE = 'INCLUDE'      // Export them anyway but mark as invalid
}
